import { get } from '../lib/frontend/quiz/spaced-repetition';
import { ResponseDueData } from '../types/quiz';
import { QueryObserverBaseResult, useQuery } from 'react-query';
import { SpacedRepetitionState } from '../types/queues';
import { useUserContext } from '@osmosis/nextjs-components/context/UserContext';

/**
 * Use for fetching quiz item metadata.
 * @export
 * @param {number} nodeID
 * @returns {*}  {({
 *   metadata: ItemMetaData | undefined;
 * })}.
 */
export default function useItemMetadata(nodeID?: number): {
  metadata: ResponseDueData | undefined;
  refetch: QueryObserverBaseResult['refetch'];
} {
  const { user } = useUserContext();

  const { data: metadata, refetch } = useQuery(
    `item-metadata-${nodeID}`,
    async () => {
      if (nodeID) {
        const item = await get(nodeID);
        return {
          nodeID: nodeID,
          eFactor: item.eFactor,
          interval: item.interval,
          repeatOn: item.repeatOn,
          flaggedOn: item.flaggedOn,
          flagged: item.state === SpacedRepetitionState.SCHEDULED_FLAGGED,
          state: item.state,
        };
      }

      return undefined;
    },
    {
      enabled: !!nodeID && !!user, // Only fetch if nodeID and user exist
    },
  );

  return {
    metadata,
    refetch,
  };
}
